module.exports = __webpack_public_path__ + "img/exclemation-mark-red.c8157d67.svg";